module.exports = __webpack_public_path__ + "img/usd-gateway.0cbe2e11.jpg";